function ToggleSwitch({
  handleClick,
  show,
  value,
  id,
  disabled,
  name,
  checked,
  title = "",
  errorMessage,
}) {


  if (!show) {
    return null;
  }

  return (
    <div title={title}>
      <label className="form-switch p-0">
        <input
          type="checkbox"
          onChange={handleClick}
          className={"form-check-input" + (!disabled ? "cursor-pointer" : "")}
          value={value}
          id={id}
          disabled={disabled}
          name={name}
          checked={checked}
          title={title}
        />
        <span
          className={"form-slider round" + (disabled ? " disabled" : "")}
        ></span>
      </label>
      {errorMessage &&
        errorMessage[name] &&
        Object?.keys(errorMessage).length > 0 && (
          <div className="text-danger fw-700 fs-6 mt-1">
            {errorMessage && errorMessage[name] && errorMessage[name]}
          </div>
        )}
    </div>
  );
}

export default ToggleSwitch;
